import React from 'react';

import LibraryTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LibraryTable />
    </div>
  );
};
